<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import LaisField from 'dashboard/components-next/LaisField.vue';

const model = defineModel({
  type: Object,
  required: true,
});

const SIGNATURES = ['digital', 'fisico', 'ambos', 'outro'];
const KEY_RULES = [
  'imobiliaria',
  'proprietario',
  'porteiro',
  'corretor',
  'outro',
];
const inputClass =
  'w-full rounded-lais border border-lais-border px-3 py-2 text-[14px] bg-white';
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <LaisCard title="Políticas">
    <div class="grid gap-3 md:grid-cols-2">
      <LaisField label="Assinatura de contrato">
        <select v-model="model.contract_signature" :class="inputClass">
          <option v-for="kind in SIGNATURES" :key="kind" :value="kind">
            {{ kind }}
          </option>
        </select>
      </LaisField>
      <LaisField label="Chave para visita">
        <select v-model="model.visit_key_rule" :class="inputClass">
          <option v-for="rule in KEY_RULES" :key="rule" :value="rule">
            {{ rule }}
          </option>
        </select>
      </LaisField>
      <LaisField label="Documento exigido para visita">
        <input v-model="model.visit_required_document" :class="inputClass" />
      </LaisField>
      <LaisField label="Detalhes extras">
        <input v-model="model.notes" :class="inputClass" />
      </LaisField>
    </div>
  </LaisCard>
</template>
